import { createActionCreator } from "common/ReduxUtils";
import { StorageCargoActionTypes } from "../StorageCargoAction.types";
import { ShipmentType } from "@deliverr/storage-client";

export const setCargoType = createActionCreator<ShipmentType>(
  StorageCargoActionTypes.STORAGE_SET_CARGO_TYPE,
  "cargoType"
);
